export const MIN_SIGNERS = 10;
